import { Component, Input, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Employee } from '@app/models/employee/employee.model';
import { BaseForm } from '@app/modules/forms/base.form';
import moment from 'moment';
import { DetachEmployee } from '../../interfaces/time-off-assign.interface';
import { TimeOffDateFormatDashes } from '../../meta/time-off-meta';

@Component({
    selector: 'app-employee-removal-form',
    templateUrl: './employee-removal.form.html',
})
export class EmployeeRemovalForm extends BaseForm {
    @Input() removals: Employee[] = [];
    @ViewChild('accrualEndDate') accrualEndDateSelect: MatSelect;

    policyDetach: DetachEmployee[] = [];
    userSelectedDate: Date = new Date();
    minDate: Date = new Date();

    setEffectiveToDate(): void {
        this.policyDetach = this.removals.map((employee) => {
            return {
                id: employee.id,
                effectiveTo: moment(this.userSelectedDate).format(TimeOffDateFormatDashes),
            };
        });
    }
}
